var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-ajax-dropdown',{staticClass:"form-control",attrs:{"allowEmpty":_vm.allowEmpty,"blacklist":_vm.blacklist,"customLabel":(option) => `${option.name}`,"disabled":_vm.isLoading,"multiple":true,"placeholder":_vm.placeholder,"query":_vm.query,"url":`/api/users`,"value":_vm.selectedResources},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }